import { useQuery } from '@tanstack/react-query';
import userRepository from '@/api/repositories/userRepository/UserRepository.ts';
import { User } from '$/models/User';

const useUser = (authId: string | null | undefined) => {
  const queryKey = ['user', authId];

  const queryFn = async () => {
    return getUser(authId);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!authId,
    refetchOnWindowFocus: false,
  });
};

export default useUser;

async function getUser(authId: string | null | undefined): Promise<User | null> {
  const user = await userRepository.findOne({
    id: authId,
  });

  if (!user || !user.data) return null;

  return user.data;
}
